export default __webpack_public_path__ + "static/media/partyRoom.d5741ae6.jpg";